import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import { useState } from "react";
import { useSession } from "../../../authentications/SessionContext";
import { create } from "../../../DataApi/create";
import { useLanguage } from "../../LangTranslation/LanguageContext";
import moment from "moment";
import {
  GET_LEAD_DETAIL_KEYS,
  LEAD_PRIORITY,
  LEAD_STATUS,
} from "../../../utilities/constants";
import { read } from "../../../DataApi/read";
import { write } from "../../../DataApi/write";
import SVGButton from "../../Buttons/SVGButton";
// images
import editIcon from "../../../Images/edit.svg";
import { countryChangeDefaultValues } from "../../../utilities/Validation Schema/onChangeDefaultOptions";
import { nameSearchCRM } from "../../../DataApi/crm/nameSearchCRM";
import { onChangeSelectCRM } from "../../../DataApi/crm/onChangeSelectCRM";
import LoaderWrapper from "../../Loader/LoaderWrapper";
import { Form, Formik } from "formik";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";
import { newLeadFOrmValidationSchema } from "../../../utilities/Validation Schema/NewLeadFormValidationSchema";
import ErrorFocus from "../../Formik/ErrorFocus";
import ExtraInformation from "./ExtraInformation";
import { findAndAddOption } from "../../../utilities/findAndAddOption";
import useListOptions from "../../../CustomHooks/useListOptions";
import { useSnackbar } from "notistack";
import { FormContainer } from "../../StyledComponents/FormConatiner/FormContainerStyle";
import InternalNotes from "./InternalNotes";
import { Button } from "../../../Components/StyledComponents/Buttons/ButtonStyle";
import { X } from "react-feather";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import { handleResponse } from "../../../utilities/handleResponse";
import ButtonSpinLoader from "../../ButtonLoader/ButtonSpinLoader";
import useFormikSubmitButton from "../../../CustomHooks/useFormikSubmitButton";
import { nameCreateGeneral } from "../../../DataApi/generalApis/nameCreateGeneral";

const NewLeadForm = ({
  handleCloseModal,
  refetchData,
  stageId,
  modalType = "add",
  selectedLead,
  setModalType,
  defaultEdit,
  setDefaultEdit,
}) => {
  const { sessionInfo } = useSession();
  const { company_id, context, user_id } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { ConfirmationModal, setMetaData, setTitle } = useConfirmationModal();

  const { setIsSubmitting, FormikSubmitButtons } = useFormikSubmitButton();
  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();
  const [isLoading, setIsLoading] = useState(true);
  const [activeCustomersList, setActiveCustomersList] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);
  const [availablePartnerTitle, setAvailablePartnerTitle] = useState([]);
  const [availableCompaign, setAvailableCompaign] = useState([]);

  const [inputs, setInputs] = useState({
    // top section
    name: "",
    active: LEAD_STATUS[0].value,
    expected_revenue: 0,
    probability: 8.28,
    partner_id: "",
    email_from: "",
    phone: "",
    date_deadline: "",
    priority: "0",
    tag_ids: [],

    // internal notes
    description: "",
    // extra information
    partner_name: "",
    street: "",
    street2: "",
    city: "",
    state_id: "",
    title: "",
    country_id: "",
    contact_name: "",
    zip: "",

    source_id: "",

    // required Data=
  });
  const [previousInputs, setPreviousInputs] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const handleNext = ({
    e,
    validateForm,
    values,
    setErrors,
    setFieldTouched,
    newTabValue = -1,
  }) => {
    e.preventDefault();
    validateForm(values).then((resp) => {
      if (Object.keys(resp)?.length === 0) {
        if (newTabValue !== -1) {
          handleNavigationItemClick(newTabValue, e);
          return;
        }
        setActiveTab(activeTab + 1);
      } else {
        setErrors(resp);
        Object.keys(resp).forEach((key, index) => {
          setFieldTouched(key, true);
        });
      }
    });
  };

  const handleNavigationItemClick = (tabIndex, e) => {
    e.preventDefault();
    e.stopPropagation(); // Stop event propagation
    setActiveTab(tabIndex);
  };
  const handleChangeCustomer = async (option, name, setFieldValue) => {
    let response = await onChangeSelectCRM({
      partner_id: Number(option.value),
      tag_id: [],
      context,
      company_id,
    });
    if (response) {
      response = JSON.parse(response);
    }
    const incomingNewValues = response?.result?.value || {};
    const { country_id, state_id, partner_id } = incomingNewValues;
    Object.keys(incomingNewValues).forEach((key) => {
      if (typeof incomingNewValues[key] !== "undefined") {
        if (typeof incomingNewValues[key] !== "object") {
          setFieldValue(
            key,
            incomingNewValues?.[key] || inputs?.[key] || false
          );
        } else {
          setFieldValue(
            key,
            incomingNewValues?.[key]?.[0] || inputs?.[key] || false
          );
        }
      }
    });

    // setFieldValue("country_id", country_id || inputs.country_id || false);
    findAndAddOption({
      incomingOption: [option.value, option.label],
      availableOptions: activeCustomersList,
      setAvailableOptions: setActiveCustomersList,
    });
    if (country_id) {
      findAndAddOption({
        incomingOption: country_id,
        availableOptions: availableCountries,
        setAvailableOptions: setAvailableCountries,
        // setFieldValue,
        // keyName: "country_id",
      });
    }
    if (state_id) {
      findAndAddOption({
        incomingOption: state_id,
        availableOptions: stateList,
        setAvailableOptions: setStateList,
        // setFieldValue,
        // keyName: "state_id",
      });
    }
  };

  const getPayload = (newInputs) => {
    const payload = {
      // new data

      stage_id: newInputs.stage_id || stageId,
      active: newInputs?.active || false,
      name: newInputs?.name,
      expected_revenue: newInputs?.expected_revenue,
      automated_probability: newInputs?.probability || false,
      probability: newInputs?.probability || false,
      partner_id: newInputs?.partner_id || false,
      street: newInputs?.street || false,
      street2: newInputs?.street2 || false,
      city: newInputs?.city || false,
      state_id: newInputs?.state_id || false,
      zip: newInputs?.zip || false,
      country_id: newInputs?.country_id || false,
      website: newInputs?.website || false,
      lang_id: newInputs?.lang_id || false,
      email_from: newInputs?.email_from || false,
      contact_name: newInputs?.contact_name || false,
      partner_name: newInputs?.partner_name || false,
      otp_to_be_verified: newInputs.otp_to_be_verified || false,
      email_verified: newInputs.email_verified || false,
      otp: newInputs.otp || false,
      phone: newInputs?.phone || false,
      title: newInputs.title || false,
      email_cc: newInputs.email_cc || false,
      function: newInputs?.function || false,
      mobile: newInputs?.mobile || false,
      date_deadline: newInputs?.date_deadline
        ? moment(newInputs?.date_deadline).format("YYYY-MM-DD")
        : false,
      priority: newInputs?.priority || "1",
      tag_ids: [[6, false, [...newInputs.tag_ids]]],
      user_id: newInputs.user_id || user_id,
      team_id: newInputs.team_id || false,
      type: newInputs.opportunity || "opportunity",
      lost_reason: newInputs.lost_reason || false,
      company_id: newInputs.company_id || company_id,
      description: newInputs?.description || false,
      campaign_id: newInputs.compaign_id || false,
      medium_id: newInputs.medium_id || false,
      source_id: newInputs.source_id || false,
      referred: newInputs.referred || false,

      message_follower_ids: newInputs.message_follower_ids || [],
      activity_ids: newInputs.activity_ids || [],
      message_ids: newInputs.message_ids || [],
    };
    return payload;
  };
  const handleAddNewLead = async (values) => {
    const payload = getPayload(values);
    // return
    let response = await create({
      payload,
      context,
      company_id,
      model: "crm.lead",
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      refetchData();
      return;
    }
    return response;
  };
  const handleEditLead = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(previousInputs);
    const newPayload = getPayload(values);
    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) != JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    let response = await write({
      id: inputs?.id,
      change: newChanges,
      company_id,
      context,
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      refetchData();
      setDefaultEdit(false);
    }
    return response;
  };

  const handleSubmitType = async (values) => {
    setIsSubmitting(true);
    let response = null;
    let successMessage = "Lead Created Successfully";
    if (modalType === "edit") {
      response = await handleEditLead(values);
      successMessage = "Lead Edited Successfully";
    } else {
      response = await handleAddNewLead(values);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
  };
  const fetchCompaignData = async () => {
    let response = await nameSearchCRM({
      model: "utm.campaign",
      context,
      company_id,
    });
    response = JSON.parse(response);
    if (response?.result) {
      const compaign = response.result.map((item) => ({
        label: item[1],
        value: item[0],
      }));
      setAvailableCompaign(compaign);
      return compaign;
    }
    return [];
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const fetchLeadDetail = async () => {
    if (!selectedLead?.id) {
      setIsLoading(false);
      return false;
    }
    let response = await read({
      id: selectedLead?.id,
      change: GET_LEAD_DETAIL_KEYS,
      company_id,
      context,
    });
    response = JSON.parse(response);
    if (response?.result?.[0]) {
      const responseData = response?.result?.[0];

      const inputsList = {
        ...inputs,
        ...responseData,
        partner_id: responseData?.partner_id?.[0],
        lang_id: responseData?.lang_id?.[0] || false,
        country_id: responseData?.country_id?.[0] || false,
        state_id: responseData?.state_id?.[0] || false,
        title: responseData?.title?.[0] || false,
        description: responseData?.description || "",
        email_from: responseData?.email_from || "",
        phone: responseData?.phone || "",
        date_deadline: responseData?.date_deadline || "",
        partner_name: responseData?.partner_name || "",
        additionalOptions: {
          partner: responseData?.partner_id || "",
          lang: responseData?.lang_id || "",
          country: responseData?.country_id || "",
          state: responseData?.state_id || "",
          partner_title: responseData?.title || "",
        },
      };
      setPreviousInputs(inputsList);
      setInputs(inputsList);
      setIsLoading(false);
      return inputsList;
    }
    return false;
  };
  const handleCreateCustomer = async (name) => {
    const response = await nameCreateGeneral({
      company_id,
      context,
      args: [name],
      model: "res.partner",
    });
    if (response.result) {
      const [value, label] = response?.result;
      findAndAddOption({
        incomingOption:response.result,
        setAvailableOptions:setActiveCustomersList
      })
      return { label, value };

    }
    return false;
  };

  const handleChangeCountry = async (
    option,
    { name },
    values,
    setFieldValue
  ) => {
    const response = await onChangeSelectCRM({
      company_id,
      context,
      keyChange: "country_id",
      values: { ...values, name: option.value },
      model: "res.country",
      defaulChange: countryChangeDefaultValues,
    });
    findAndAddOption({
      setFieldValue,
      keyName: "country_id",
      incomingOption: [option.value, option.label],
      availableOptions: availableCountries,
      setAvailableOptions: setAvailableCountries,
    });
    const incomingValues = response?.result?.value || {};
    Object.keys(incomingValues)?.forEach((key) => {
      setFieldValue(key, incomingValues[key]);
    });
    handleCustomSearch({
      model: "res.country.state",
      args: [["country_id", "=?", option.value]],
      setState: setStateList,
    });
  };

  useEffect(() => {
    if (selectedLead.id) {
      setModalType("view");
    } else {
      setModalType("add");
    }
    fetchLeadDetail().then((response) => {
      if (!response) return;
      const {
        partner = "",
        lang = "",
        state = "",
        country = "",
        partner_title = "",
      } = response.additionalOptions;

      findAndAddOption({
        availableOptions: activeCustomersList,
        incomingOption: partner,
        setAvailableOptions: setActiveCustomersList,
      });
      findAndAddOption({
        availableOptions: languageList,
        incomingOption: lang,
        setAvailableOptions: setLanguageList,
      });
      findAndAddOption({
        availableOptions: stateList,
        incomingOption: state,
        setAvailableOptions: setStateList,
      });
      findAndAddOption({
        availableOptions: availableCountries,
        incomingOption: country,
        setAvailableOptions: setAvailableCountries,
      });
      findAndAddOption({
        availableOptions: availablePartnerTitle,
        incomingOption: partner_title,
        setAvailableOptions: setAvailablePartnerTitle,
      });
    });
    handleCustomSearch({
      model: "crm.tag",
      setState: setAvailableTags,
    });
    if (defaultEdit) {
      setModalType("edit");
    }
  }, [selectedLead]);

  useEffect(() => {
    if (
      (modalType === "edit" && inputs.additionalOptions) ||
      modalType === "add"
    ) {
      const { partner, lang, state, country, partner_title } =
        inputs?.additionalOptions || {};
      handleCustomSearch({
        model: "res.partner",
        context,
        company_id,
        setState: setActiveCustomersList,
        staticOptions: partner ? [partner] : [],
      });
      handleCustomSearch({
        model: "res.lang",
        context,
        company_id,
        setState: setLanguageList,
        staticOptions: lang ? [lang] : [],
      });
      handleCustomSearch({
        model: "res.country.state",
        setState: setStateList,
        staticOptions: state ? [state] : [],
      });
      handleCustomSearch({
        model: "res.country",
        setState: setAvailableCountries,
        staticOptions: country ? [country] : [],
      });

      handleCustomSearch({
        model: "res.partner.title",
        context,
        company_id,
        setState: setAvailablePartnerTitle,
        staticOptions: partner_title ? [partner_title] : [],
      });
    }
  }, [modalType, selectedLead?.id]);

  const disableInputs = useMemo(() => modalType === "view", [modalType]);
  return (
    <div style={{ maxWidth: "900px", height: "95vh", padding: "10px" }}>
      <ConfirmationModal />
      <Formik
        enableReinitialize
        initialValues={inputs}
        validationSchema={newLeadFOrmValidationSchema}
        onSubmit={handleSubmitType}
      >
        {({
          values,
          setFieldValue,
          errors,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <Form>
            <FormContainer className="row g-3 px-2">
              <div className="row p-0 justify-content-between align-items-center">
                <div className="col">
                  <h3
                    className="me-2 mb-2 "
                    style={{
                      fontFamily: "Inter",
                      color: "#323B4B",
                      fontWeight: 600,
                    }}
                  >
                    {modalType === "add" && "New Lead"}
                    {modalType === "edit" && "Edit Lead"}
                    {modalType === "view" && "Lead"}
                  </h3>
                </div>
                {modalType === "view" && (
                  <div className="col d-flex justify-content-end p-0">
                    <SVGButton
                      icon={editIcon}
                      onClick={() => {
                        setModalType("edit");
                      }}
                      className="me-2"
                    />
                  </div>
                )}
              </div>

              <LoaderWrapper isLoading={isLoading} height="70vh" width="900px">
                <div className="col-md-6">
                  <FormikInput
                    name="name"
                    label={t["Opportunity Name"]}
                    disabled={disableInputs}
                  />
                </div>
                <div className="col-md-6">
                  <FormikSelect
                    name="active"
                    options={LEAD_STATUS}
                    disabled={disableInputs}
                    label={t["Status"]}
                  />
                </div>
                <div className="col-md-6">
                  <FormikInput
                    type="number"
                    disabled={disableInputs}
                    name="expected_revenue"
                    label={t["Expected Revenue"]}
                  />
                </div>
                <div className="col-md-6">
                  <FormikInput
                    type="number"
                    disabled={disableInputs}
                    name="probability"
                    label={t["Probability"]}
                  />
                </div>

                <div className="col-md-4">
                  <FormikSelect
                    name="partner_id"
                    options={activeCustomersList}
                    disabled={disableInputs}
                    label={t["Customer"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({
                        ...args,
                        model: "res.partner",
                      })
                    }
                    handleCreate={handleCreateCustomer}
                    onChange={(option, { name }) => {
                      handleChangeCustomer(option, name, setFieldValue);
                    }}
                    // handleLoadMore={fetchCustomersData}
                  />
                </div>
                <div className="col-md-4">
                  <FormikInput
                    disabled={disableInputs}
                    name="email_from"
                    type="email"
                    label={t["Email"]}
                  />
                </div>

                <div className="col-md-4">
                  <FormikInput
                    name="phone"
                    label={t["Phone"]}
                    disabled={disableInputs}
                  />
                </div>
                <div className="col-md-4">
                  <FormikInput
                    type="date"
                    disabled={disableInputs}
                    name="date_deadline"
                    label={t["Expected Closing"]}
                  />
                </div>
                <div className="col-md-4">
                  <FormikSelect
                    name="priority"
                    disabled={disableInputs}
                    options={LEAD_PRIORITY}
                    label={t["Priority"]}
                  />
                </div>
                <div className="col-md-4">
                  <FormikSelect
                    name="tag_ids"
                    isMulti
                    disabled={disableInputs}
                    options={availableTags}
                    handleSearch={({ ...args }) => {
                      handleCustomSearch({ ...args, model: "crm.tag" });
                    }}
                    label={t["Tags"]}
                  />
                </div>
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className={`nav-link ${activeTab === 0 ? "active" : ""}`}
                      onClick={(e) => {
                        handleNext({
                          e,
                          validateForm,
                          values,
                          setErrors,
                          setFieldTouched,
                          newTabValue: 0,
                        });
                      }}
                    >
                      {t["Internal Notes"]}
                    </button>
                    <button
                      className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                      onClick={(e) => {
                        handleNext({
                          e,
                          validateForm,
                          values,
                          setErrors,
                          setFieldTouched,
                          newTabValue: 1,
                        });
                      }}
                    >
                      {t["Extra Information"]}
                    </button>
                  </div>
                </nav>

                <div className="tab-content" id="nav-tabContent">
                  <div
                    className={`tab-pane fade overflow-auto show active`}
                    id="nav-home"
                    role="tabpanel"
                    type="button"
                    aria-labelledby="nav-home-tab"
                    tabIndex="0"
                  >
                    {activeTab === 0 && (
                      <InternalNotes
                        inputs={inputs}
                        disabled={disableInputs}
                        handleInputChange={handleInputChange}
                      />
                    )}
                    {activeTab === 1 && (
                      <ExtraInformation
                        keyName="crm_lead"
                        inputs={inputs}
                        setFieldValue={setFieldValue}
                        handleChangeCountry={handleChangeCountry}
                        handleCustomSearch={handleCustomSearch}
                        values={values}
                        handleInputChange={handleInputChange}
                        stateList={stateList}
                        availableCountries={availableCountries}
                        activeCustomersList={activeCustomersList}
                        availableCompaign={availableCompaign}
                        handleChangeCustomer={handleChangeCustomer}
                        availablePartnerTitle={availablePartnerTitle}
                        languageList={languageList}
                        disabled={disableInputs}
                      />
                    )}
                  </div>
                </div>
              </LoaderWrapper>

              {!disableInputs && (
                <FormikSubmitButtons handleCloseModal={handleCloseModal} />
              )}
            </FormContainer>
            <ErrorFocus />
          </Form>
        )}
      </Formik>
      {/* </form> */}
    </div>
  );
};

export default NewLeadForm;
